const time = {
  ms: seconds => seconds * 1000,
  s: milliseconds => milliseconds / 1000
};
export { time };